import React from 'react'
import PropTypes from 'prop-types'
import SocialIcon from '../SocialIcon'
import styled from 'styled-components'
import { getAbsoluteLink } from '../../helpers/utils'

const List = styled.div(({ withHeading, style = {} }) => {
  const { a, ...rest } = style
  return {
    listStyleType: 'none',
    margin: '0',
    padding: '0 0 50px 0',
    '@media only screen and (min-width: 320px)': {
      '&.col-nested': { padding: '0' }
    },
    'li:not(:last-child)': {
      paddingBottom: '10px',
      ...(withHeading && {
        '@media only screen and (max-width: 768px)': { paddingBottom: '30px' }
      })
    },
    a: {
      fontSize: '12px',
      letterSpacing: '0',
      lineHeight: '20px',
      borderBottom: '0',
      display: 'block',
      transition: 'all 0.2s ease-in-out',
      color: 'var(--white)',
      textDecoration: 'none',
      fontWeight: 700,
      '&:hover': {
        color: 'var(--grey-6)'
      },
      ...a
    },
    ...rest
  }
})

const FooterList = styled.div(({ style = {} }) => {
  const { a, ...rest } = style
  return {
    listStyleType: 'none',
    margin: '0',
    padding: '0',
    a: {
      fontSize: '12px',
      letterSpacing: '0.5px',
      lineHeight: '20px',
      paddingBottom: '10px',
      borderBottom: '0',
      fontWeight: 400,
      display: 'block',
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out',
      color: 'var(--white)',
      textDecoration: 'none',
      '&:hover': {
        color: 'var(--grey-6)'
      },
      ...a
    },
    ...rest
  }
})

const ImageList = styled(FooterList)({
  li: {
    display: 'inline-block',
    padding: '0 15px 0 15px',
    '&:first-child': { paddingLeft: '0', paddingRight: '15px' }
  }
})

const H2 = styled.h2(({ style }) => {
  return {
    color: 'var(--white)',
    fontSize: '18px',
    fontWeight: 700,
    letterSpacing: '0.5px',
    lineHeight: '24px',
    marginBottom: '0',
    paddingBottom: '20px',
    ...style
  }
})

const vStyle = {
  v2: {
    linkList: {
      marginBottom: '100px',
      '@media only screen and (minWidth: 320px)': { marginBottom: '80px' }
    }
  },
  v3: {
    linkList: {
      marginBottom: '100px',
      '@media only screen and (minWidth: 320px)': { marginBottom: '80px' }
    }
  },
  v4: {
    headline: {
      color: 'var(--dark) !important'
    },
    linkList: {
      a: {
        color: 'var(--grey-1) !important',
        fontWeight: 400,
        lineHeight: '20px',
        '&:hover': {
          textDecoration: 'underline !important'
        }
      },
      img: {
        marginBottom: '50px'
      }
    }
  }
}

const FooterLinkList = ({ links, item, isNested, version }) => {
  const isImageList = links.every(link => link.linkIcon !== null)
  const LinksList = isImageList ? ImageList : List
  const { headline, linkList } = vStyle[version] || {}
  return (
    <div className="m-auto">
      {item.heading && (
        <H2 className="subtitle-two text-capitalize" style={headline}>
          {item.heading.toLowerCase()}
        </H2>
      )}
      <LinksList
        withHeading={!!item.heading}
        className={`${isNested ? 'col-nested' : ''}`}
        style={linkList}
      >
        {item.links.map((link, index) => (
          <li key={index}>
            <a
              href={getAbsoluteLink(link.linkUrl)}
              aria-label={link.linkAltText}
              rel={link.doNotFollowLink}
            >
              {link.linkText && link.linkText}
              {link.linkIcon && (
                <SocialIcon
                  alt={link.linkAltText}
                  title={link.linkAltText}
                  image={getAbsoluteLink(link.linkIcon, version)}
                />
              )}
            </a>
          </li>
        ))}
      </LinksList>
    </div>
  )
}

FooterLinkList.propTypes = {
  item: PropTypes.object,
  links: PropTypes.array,
  isNested: PropTypes.bool,
  version: PropTypes.string
}

export default FooterLinkList



// WEBPACK FOOTER //
// ./src/components/Footer/FooterLinkList.js